var useTable = function useTable(props) {
  var border = props.border;

  if (border) {
    return {
      borderWidth: 'border',
      borderColor: 'border-gray-200'
    };
  }

  return {};
};
var useTableDataCell = function useTableDataCell(props) {
  var spacing = props.spacing;

  var mapPadding = function mapPadding() {
    switch (spacing) {
      case 'comfortable':
        return ['px-6', 'py-3'];

      case 'compact':
        return ['px-4', 'py-1'];

      default:
      case 'cozy':
        return ['px-5', 'py-2'];
    }
  };

  return {
    padding: mapPadding(),
    borderWidth: 'border-b',
    borderColor: 'border-gray-200'
  };
};
var useTableHeaderCell = function useTableHeaderCell(props) {
  var spacing = props.spacing,
      onClick = props.onClick;

  var mapPadding = function mapPadding() {
    var padding;

    switch (spacing) {
      case 'comfortable':
        padding = ['px-6', 'py-4', onClick ? 'pr-3' : null];
        break;

      case 'compact':
        padding = ['px-4', 'py-2', onClick ? 'pr-2' : null];
        break;

      default:
      case 'cozy':
        padding = ['px-5', 'py-3', onClick ? 'pr-2.5' : null];
        break;
    }

    return padding.filter(Boolean);
  };

  return {
    padding: mapPadding(),
    fontSize: 'text-xs',
    fontWeight: 'font-semibold',
    letterSpacing: 'tracking-wide',
    textAlign: 'text-left',
    textColor: 'text-gray-500',
    textTransform: 'uppercase',
    borderWidth: 'border-b',
    borderColor: 'border-gray-200',
    backgroundColor: 'bg-gray-50'
  };
};

export { useTable, useTableDataCell, useTableHeaderCell };
//# sourceMappingURL=use-table.esm.js.map
